import React, { FC } from "react";
import classNames from "classnames";

export interface TagProps {
  href: string;
  onClose?: () => void;
}

export const Tag: FC<TagProps> = ({ href, children, onClose }) => {
  const tagClassName = classNames({
    "xvia-tag": true,
  });

  return (
    <a
      className={tagClassName}
      href={href}
      style={
        onClose
          ? { display: "flex", alignItems: "center", gap: "4px" }
          : undefined
      }
    >
      {children}

      {onClose && (
        <span
          onClick={(e) => {
            e.preventDefault();
            onClose();
          }}
          style={{
            cursor: "pointer",
            marginLeft: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          ×
        </span>
      )}
    </a>
  );
};